<template>
  <BaseFiltersSideBar
    v-model="model"
    @filters-submit="onFiltersSubmit"
  >
    <NonConformitiesListFiltersForm
      ref="non-conformities-list-filters-form"
      v-model="filters"
      @submit="onFiltersSubmit"
    />
  </BaseFiltersSideBar>
</template>

<script>
import BaseFiltersSideBar from '@/components/ui/sidebar/BaseFiltersSideBar.vue'
import NonConformitiesListFiltersForm from '@/components/non-conformities/form/NonConformitiesListFiltersForm.vue'

export default {
  name: 'NonConformitiesListFilters',
  components: {
    NonConformitiesListFiltersForm,
    BaseFiltersSideBar,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      filters: {},
    }
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      },
    },
  },
  methods: {
    clearFilters() {
      this.$refs['non-conformities-list-filters-form'].clearForm()
    },
    onFiltersSubmit() {
      this.model = false
      this.$emit('filters-submit', this.filters)
    },
  },
}
</script>

<style lang="scss">
</style>
